import { IObservable, Subject } from '~/rage/utils';
import { ICatchRingService } from './catchRingServiceTypes';

export class CatchRingServiceStub implements ICatchRingService {
	private actionName = new Subject<string>('Добыть древесину');

	getActionName(): IObservable<string> {
		return this.actionName;
	}

	async catch(success: boolean): Promise<void> {
		console.log('catchRing:catch', success);
	}

	async exit(): Promise<void> {
		console.log('catchRing:exit');
	}
}
